import { BaseFiltroPagDTO, IdNomeDTO, JsonException, TipoArquivoDTO } from './base-dto';
import { IBusinessUnit } from './business-units';
import { IUnitClient } from './client';
import IDoctor from './doctor';

interface IUser {
  id?: string;
  idMedico?: string;
  idUsuario?: string;
  nome: string;
  email: string;
  cpf?: string;
  crm?: string;
  crmUF?: string;
  telefone?: string;
  celular?: string;
  perfil: {
    id: string;
  };
  unidadesEmpresariais?: any[];
  unidadesCliente?: any[];
  tipoAcesso: TypeAccessType;
  tipoLogin: TypeUserType;
  ativo: boolean;
  motivoInativacao?: string;
  temHistoricoAtivacao?: boolean;
  aceitaNotificacaoEmail?: boolean;
  aceitaNotificacaoWhatsapp?: boolean;
  lideres?: any[];
  cdsAreasGeograficas?: any[];
  celValidado?: boolean;
}

interface ICurrentUser {
  id?: string;
  idUsuario?: string;
  idMedico?: string;
  nome: string;
  email: string;
  cpf?: string;
  crm?: string;
  crmUF?: string;
  telefone?: string;
  celular?: string;
  tipoAcesso: TypeAccessType;
  tipoLogin: TypeUserType;
  senha?: string;
  novaSenha?: string;
  novaSenhaConfirma?: string;
}

interface IUserSessionData {
  empresa?: IBusinessUnit;
  empresas?: IBusinessUnit[];
  idEmpresa?: string;
  empresaCNPJ?: string;
  idUnidadeCliente?: number;
  medico?: IDoctor;
  menu?: any;
  perfil: any;
  senhaExpirada?: boolean;
  unidadeCliente?: string;
  unidadesCliente?: IUnitClient[];
  usuario: string;
}

export class LoginPreAtivacaoDadosDTO {
  idLogin: Number;
  cpfCrm: string;
  medico: boolean;
  nome: string;
  dataCriacao: Date;
  ultimoLogin: Date;
  qtdePrescricoes: Number;
  ativo: boolean;
}

export class LoginAtivacaoParmDTO {
  idLogin: Number;
  ativo: boolean;
  motivo: string;
}

export class LoginUnidadesParmDTO {
  idLogin: Number;
  idsUnidades: Number[];
}

export class LoginUsuarioParmDTO {
  id: number;
  nome: string;
  email: string;
  cpf: string;
  cienteCpfExiste: boolean;
  crm: string;
  crmUF: string;
  telefone: string;
  celular: string;
  ativo: boolean;
  idPerfil: number;
  idsUnidadesEmpresariais: number[];
  idsUnidadesCliente: number[];
  tipoAcesso: string;
  tipoLogin: string;
  aceitaNotificacaoEmail: boolean;
  aceitaNotificacaoWhatsapp: boolean;
  idsLideres: number[];
  cdsAreasGeograficas: string[];
  tipoCicloPlanejamento: string;
}

export class UsuarioCpfCrmExistenteException extends JsonException {
  cpf: string;
  crm: string;
  validacaoCrm: boolean;  
  nomeUsuario: string;
}

export class EsqueciSenhaIniciarResult {
  nome: string;
  cpfCrm: string;
  uuid: string;
  msg: string;
  showTermosUso: boolean;
  termosUsoUrl: string;
}

export class EsqueciSenhaValidarResult {
  justificarFaltaUso: boolean;
  mensagemJustificar: string;
}

export class PreAtivacaoIniciarResult {
  crm: string;
  nome: string;
  uuid: string;
  msg: string;
  pathLiConcordo: string;
  documentosNecs: TipoArquivoDTO[];
  ajustes: boolean;
}

export class UsuarioAnaliseEfetivacaoResult {
  nome: string;
  cpfCrm: string;
  situacao: IdNomeDTO;
  dataSituacao: Date;
  alteravel: boolean;
  docs: DocumentoEfetivacao[];
  observacao: string;
  analista: string;
}

export class DocumentoEfetivacao {
  id: number;
  nomeOriginal: string;
  path: string;
  tipo: IdNomeDTO;
  situacao: IdNomeDTO;
  analisar: boolean;
  download: boolean;
  aprovado: Boolean;
}

export class EfetivacaoAnaliseDocsParm {
  uuid: string;
  mensagemAoUsuario: string;
  documentos: EfetivacaoAnaliseDocParm[];
  solicitarAjustes: boolean;
}

export class EfetivacaoAnaliseDocParm {
  id: number;
  aprovado: boolean;
  motivo: string;
}

export class UsuarioFiltroParmDTO extends BaseFiltroPagDTO {
  nomeEmailCpfCrm: string;
  idUnidadeCliente: number;
  idPerfil: number;
  tipoAcesso: string;
  tipoLogin: string;
  ativo: string;
  situacaoEfetivacao: string;
}


type TypeAccessType = 'EMEDE' | 'CLIENTE';
type TypeUserType = 'MEDICO' | 'USUARIO';

export { IUser, ICurrentUser, IUserSessionData, TypeAccessType, TypeUserType };
